import React from "react"
import { Helmet } from "react-helmet-async"
import { Container } from "reactstrap"
import PurchaseOrders from "components/PurchaseOrders"

import EntitlementPageGuard from "components/Subscription/EntitlementPageGuard"
import { PURCHASE_ORDERS } from "constants/entitlements"

const PurchaseOrdersIndex = () => {
  return (
    <EntitlementPageGuard permission={PURCHASE_ORDERS}>
      <div className="page-content">
        <Helmet>
          <title>Planhopper | Pedidos de compra</title>
        </Helmet>
        <Container fluid>
          <PurchaseOrders />
        </Container>
      </div>
    </EntitlementPageGuard>
  )
}

export default PurchaseOrdersIndex
